import * as netlineIcons from '@lsy-netline/netline-ui/icons';

import * as muiIcons from './mui-icons';

const icons = { ...muiIcons, ...netlineIcons };

export * from './mui-icons';
export * from '@lsy-netline/netline-ui/icons';

export default icons;
